import {   
    FormControl,   
    InputLabel,
    MenuItem,
    Select,   
    Button,   
    Typography,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContentText,       
    TextField,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IDetalheFaleConosco, IFile, UtilidadeService, dropOpcoesFaleConosco } from "../../shered/services/api/utilidades/UtilidadesService";
import { MuiFileInput } from "mui-file-input";
import { Loading } from "../../shered/components/loading/Loading";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export interface IDadosModalEvento {
    mensagem: string;
    label: string;
    titulo: string;
    acao: boolean;
    display: string;
    tipo: "error" | "warning" | "info" | "success";
    evento?: string;
    info?: any;

}
export type IModalProps = {
    //dados: IDadosModalEvento;
    children?: React.ReactNode;
    isModalVisible: boolean;
    onBackClickClose: () => void;
}


export const DialogFaleConoscoEvent: React.FC<IModalProps> = ({ onBackClickClose, isModalVisible }) => {
    const [open, setOpen] = useState(isModalVisible);
    const [checked, setChecked] = useState(false);
    const navigate = useNavigate();
    const user = CookieService.get("access_user");
    const [isLoading, setIsLoading] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [showModalFaleConosco, setShowModalFaleConosco] = useState(false);
    const [codigoOpcaoAssunto, setCodigoOpcao] = useState(0);
    const [dadosArquivo, setDadosArquivo] = useState<IFile>();
    const [arquivo, setArquivo] = useState<any | null>("");
    const [redirecionar, setRedirecionar] = useState("");
    const [mensagem, setMensagem] = useState("");
    //const [dadosSalvar, setDadosSalvar ] = useState<IDetalheFaleConosco>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    useEffect(() => {
        setIsLoading(false);
        setRemoveLoading(true);
        if (!isModalVisible) {
            return;
        }
        else {
            setShowModalFaleConosco(true);
        }
        return;
    }, []);
    const handleClickOpen = () => {
        setOpen(true);
        onBackClickClose();
    };
    const handleClose = () => {
        setOpen(false);
        onBackClickClose();

    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        handleClose();
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }

    }

    const handleChangeFile = (newFile: any) => {
        //console.log(newFile);
        setArquivo(newFile);
        // if (dadosArquivo !== undefined) {
        //     setDadosArquivo({
        //         ...dadosArquivo,
        //         files: [...dadosArquivo.files, ...e.target.files],
        //     });
        // }
    }

    const handleSalvarContato = async () => {
        setIsLoading(true);
        setRemoveLoading(false);
        var dadosSalvar: IDetalheFaleConosco = {
            codigo: 0,
            codUsuCriacao: user.codUsuario,
            arquivos: arquivo,
            arquivo_Anexo: "",                    
            mensagem: mensagem, 
            tipo: codigoOpcaoAssunto
        };
        if (arquivo !== null && arquivo !== "") {            
             await UtilidadeService.upLoadArquivo(arquivo)
            .then(respImg=> {             
                if (respImg.data.statusHTTP === 200) {
                    let dadosArquivo = respImg.data.dado[0];                    
                    dadosSalvar = {
                        codigo: 0,
                        codUsuCriacao: user.codUsuario,
                        arquivos: arquivo,                   
                        arquivo_Anexo: dadosArquivo.nome,                    
                        mensagem: mensagem,
                        tipo: codigoOpcaoAssunto
                    };

                }
              
            }).catch((erros) => {

            });
           
        }

        //handleClose();
        //console.log(dadosSalvar);
        UtilidadeService.createFaleConosco(dadosSalvar)
            .then((result) => {
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Contato registrado com sucesso! Aguarde que entraremos em contato, obrigado!",
                    display: "none",
                    titulo: "Sucesso"
                });
                setIsLoading(false);
                setRemoveLoading(true);
                setRedirecionar("0");
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível salvar os dados, tente novamente mais tarde! Caso não conseguir, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    return (
        <div >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Button variant="outlined" onClick={handleClickOpen} sx={{ display: "none" }}>
                Fale Conosco
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Fale Conosco
                </BootstrapDialogTitle>
                <DialogContent dividers sx={{ minWidth: "500px" }}>
                    <DialogContentText>
                        <Typography variant="h6">
                            Deixe-nos saber um pouco mais sobre como está a sua satisfação e usabilidade do nosso Fantasy para ver como podemos ajudá-lo da melhor maneira.
                        </Typography>
                        <Grid container  size={{ xs: 12, sm: 12 }}  direction="column">
                            <Grid container size={{xs:12, sm:12}} margin={2} direction="row" spacing={2} sx={{ width: "90%" }}>
                                <Grid size={{xs:12, sm:4}} >
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Assunto</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Assunto"
                                            value={codigoOpcaoAssunto}
                                            onChange={(e) => setCodigoOpcao(Number(e.target.value))}
                                            defaultValue={0}>
                                            <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                            {
                                                dropOpcoesFaleConosco.map(qtd =>
                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid  size={{xs:12, sm:12}} >
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Mensagem"
                                        multiline
                                        rows={6}
                                        fullWidth
                                        value={mensagem}
                                        onChange={(e) => setMensagem(e.target.value)}
                                    //defaultValue="Default Value"
                                    />
                                </Grid>
                                <Grid size={{xs:12, sm:8}} >
                                    <MuiFileInput
                                        //multiple
                                        value={arquivo}
                                        onChange={handleChangeFile}
                                    />
                                </Grid>
                            </Grid>
                            <Grid  size={{ xs: 12, sm: 12 }} spacing={2}>
                            {(!removeLoading || isLoading) && <Loading />}
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    {showModalFaleConosco && <Button disabled={!removeLoading || isLoading} onClick={() => handleSalvarContato()} autoFocus>Enviar</Button>}
                </DialogActions>
            </BootstrapDialog>
        </div >
    )
};